import React from 'react';
import axios from 'axios';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { get, map, merge } from 'lodash';
import LabelView from './LabelView';
import Loading from './Loading';
import InfoBox from './InfoBox';
import InfoBoxItem from './InfoBoxItem';
import { ANALYSIS_API_HOST, API_HOST } from '../consts';
import ItemConteudo from './ItemConteudo';
import { Form } from 'informed';
import InputSelect from './inputs/InputSelect';
import ParametroItem from './ParametroItem';
import AnaliseDados from '../pages/analise-psicometrica/AnaliseDados';
import ParametroItemAnalise from './ParametroItemAnalise';

class Item extends React.Component {
  static defaultProps = {
    hasParametro: true,
    ocultar_nome_autor: false
  };

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
  }

  state = {
    activeTab: 'conteudo',
    matrizes_referencia: [],
    fetchingMatrizesReferencia: true,
    historicoUtilizacao: {},
    fetchingHistoricoUtilizacao: true,
    fetchingBibliografiaComplementar: true,
    possuiBibliografiaComplementar: false,
    fetchingAnaliseR: false,
    fetchingAnalise: false,
    fetchingRevisao: true,
    revisoes: [],
  };

  toggle(tab) {
    this.setState({ activeTab: tab });
    const {
      fetchingMatrizesReferencia,
      fetchingHistoricoUtilizacao,
      fetchingBibliografiaComplementar
    } = this.state;

    if (tab === 'matrizes_referencia' && fetchingMatrizesReferencia) {
      this.fetchMatrizesReferencia();
    }

    if (tab === 'historico_utilizacao' && fetchingHistoricoUtilizacao) {
      this.fetchHistoricoUtilizacao();
    }
    if (tab === 'bibliografias' && fetchingBibliografiaComplementar) {
      this.fetchPedido();
    }
    if (tab === 'revisao_item' && this.state.fetchingRevisao) {
      this.fetchRevisoes();
    }
  }

  fetchRevisoes = () => {
    return axios
      .get(`${API_HOST}/revisoes/revisao/summary`, {
        params: {
          item: get(this.props, 'item.id'),
          ordering: '-finalizado_em'
        }
      })
      .then((response) => {
        this.setState({
          revisoes: response.data.results.filter((d) => d.criado_por !== null),
          fetchingRevisao: false
        });
      });
  };

  renderAreasConhecimento() {
    const areas_conhecimento = get(this.props, 'item.areas_conhecimento', []);

    if (areas_conhecimento.length === 0) {
      return '-';
    }

    return (
      <ul className="style-list">
        {areas_conhecimento.map((a) => (
          <li key={a}>{a}</li>
        ))}
      </ul>
    );
  }

  renderDados() {
    return (
      <div className="row">
        <div className="col-sm-4">
          <LabelView
            title="Áreas do conhecimento"
            text={this.renderAreasConhecimento()}
          />
        </div>
        <div className="col-sm-4">
          <LabelView
            title="Exame"
            text={get(this.props, 'item.exame.descricao')}
          />
        </div>
        <div className="col-sm-4">
          <LabelView
            title="Tipo de item"
            text={get(this.props, 'item.tipo.descricao')}
          />
        </div>
      </div>
    );
  }

  fetchMatrizesReferencia() {
    axios
      .get(`${API_HOST}/itens/item_matriz_referencia`, {
        params: {
          item: get(this.props, 'item.id'),
          ordering: '-id'
        }
      })
      .then((response) => {
        this.setState({
          matrizes_referencia: response.data,
          fetchingMatrizesReferencia: false
        });
      });
  }

  fetchPedido() {
    axios
      .get(`${API_HOST}/encomenda/encomenda`, {
        params: {
          compativel_com: get(this.props, 'item.id')
        }
      })
      .then((response) => {
        this.setState({
          possuiBibliografiaComplementar: get(
            response.data,
            'results[0].has_complementary_bibliography',
            false
          ),
          fetchingBibliografiaComplementar: false
        });
      })
      .catch((e) => {
        this.setState({
          fetchingBibliografiaComplementar: false
        });
      });
  }

  fetchHistoricoUtilizacao() {
    axios
      .get(`${API_HOST}/analises/analise_item/historico_utilizacao`, {
        params: {
          item: get(this.props, 'item.id')
        }
      })
      .then((response) => {
        this.setState({
          historicoUtilizacao: response.data,
          fetchingHistoricoUtilizacao: false
        });
      })
      .catch((e) => {
        this.setState({
          fetchingHistoricoUtilizacao: false
        });
      });
  }

  get parametrosGabarito() {
    const { parametros, itemSelecionado } = this.state;

    if (itemSelecionado) {
      return get(
        parametros,
        `${itemSelecionado.posicao_corrigida - 1}.${itemSelecionado.gabarito}`
      );
    }
    return null;
  }

  get bisserial() {
    return (get(this.parametrosGabarito, 'bisserial') || '').toLocaleString(
      'pt-BR'
    );
  }

  get discriminacao() {
    return (get(this.parametrosGabarito, 'discriminacao') || '').toLocaleString(
      'pt-BR'
    );
  }

  get dificuldade() {
    return (get(this.parametrosGabarito, 'dificuldade') || '').toLocaleString(
      'pt-BR'
    );
  }

  fetchAnaliseR = (analise) => {
    this.setState({ fetchingAnalise: true });

    Promise.all([
      axios.get(
        `${ANALYSIS_API_HOST}/analise_tct/${analise}/analise_estatistica/`
      ),
      axios.get(`${ANALYSIS_API_HOST}/analise_tct/${analise}/intervalos/`)
    ]).then((responses) => {
      const d1 = responses[0].data;
      const d2 = responses[1].data;
      this.setState({
        parametros: d1.map((_, i) => ({
          ...merge(d1[i], d2[i])
        }))
      });
      this.setState({ fetchingAnalise: false });
    }).catch(() => {
      this.setState({ fetchingAnalise: false });
    });
  };

  fetchAnalises(analise) {
    const externalId = get(analise, 'value')
    this.setState({ fetchingAnalise: true });
    return axios
      .get(`${API_HOST}/analises/analise/${externalId}`)
      .then((response) => {
        this.setState({ itemSelecionado: response.data.itens.find(data => data.id === get(this.props, 'item.id')) });
        this.fetchAnaliseR(externalId)
        this.setState({ fetchingAnalise: false });
      }).catch(() => {

        this.setState({ fetchingAnalise: false });
      });
  }

  renderRevisaoItem() {
    const { fetchingRevisao, revisoes } = this.state;

    if (revisoes.length === 0) {
      return (
        <div className="col-md-12">
          <p className="azul">
            <i className="fas fa-exclamation-circle" /> Este item ainda não passou por nenhuma revisão.
          </p>
        </div>
      );
    }
    return (
      <div>
        {fetchingRevisao && <Loading />}
        {!fetchingRevisao && (
          <div>
            <span className="azul" style={{ fontWeight: 600 }}>Revisões realizadas</span>
            <InfoBoxItem className="float-right" label="Total de revisões" value={revisoes.length} />
            <div className="mt-2" style={{ maxHeight: '70vh', overflow: 'scroll' }}>
              {revisoes.map((data) => (
                <React.Fragment key={get(data, 'id')}>
                  <InfoBox>
                    <div className="row">
                      <InfoBoxItem
                        className="col-md-4"
                        label="Data da revisão"
                        value={get(data, 'finalizado_em', '-')}
                      />
                      {!get(data, 'ocultar_revisor') && (
                        <InfoBoxItem
                          className="col-md-4"
                          label="Revisor"
                          value={get(data, 'criado_por.last_name')}
                        />
                      )}
                      <InfoBoxItem
                        className="col-md-4"
                        label="Item definido como"
                        value={get(data, 'status_item.descricao', 'Não definido')}
                      />
                    </div>
                  </InfoBox>
                  {get(data, 'comentario_elaborador') && (
                    <InfoBox text="Comentário do elaborador">
                      <div style={{ fontSize: '13px', color: '#767E81' }}>{get(data, 'comentario_elaborador', '-')}</div>
                      {get(data, 'data_comentario') && (
                        <div
                          className="text-muted small mt-2"
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center'
                          }}
                        >
                          <i className="far fa-clock mr-2" />
                          {get(data, 'data_comentario')}
                        </div>
                      )}
                    </InfoBox>
                  )}
                  <InfoBox text="Comentários do Revisor">
                    {get(data, 'comentario') !== '' ? (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: get(data, 'comentario')
                        }}
                      />
                    ) : (
                      <span
                        className="mb-0 info-box-item"
                        style={{ fontSize: '14px', marginTop: '-6px' }}
                      >
                        Não há comentários
                      </span>
                    )}
                  </InfoBox>
                  <hr />
                </React.Fragment>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  }

  renderAnaliseItem() {
    const { itemSelecionado, fetchingAnalise } = this.state
    const { item } = this.props;

    const color = [
      {
        name: 'Muito Fácil',
        min_dificuldade: 85,
        max_dificuldade: 100,
        color: '#52CE50'
      },
      {
        name: 'Fácil',
        min_dificuldade: 65,
        max_dificuldade: 85,
        color: '#267ed1'
      },
      {
        name: 'Médio',
        min_dificuldade: 35,
        max_dificuldade: 65,
        color: '#ff8e2e'
      },
      {
        name: 'Difícil',
        min_dificuldade: 15,
        max_dificuldade: 35,
        color: '#aa3f3e'
      },
      {
        name: 'Muito Difícil',
        min_dificuldade: 0,
        max_dificuldade: 15,
        color: '#8470FF'
      }

    ];

    const dificuldadeResult = {
      ...this.parametrosGabarito,
      discriminacao: this.discriminacao,
      bisserial: this.bisserial,
      acertos: parseFloat(this.dificuldade),
      dificuldade: color.filter(
        (d) => d.name === get(item, 'dificuldade.descricao')
      )[0]
    };
    let analiseItem = '';
    let descricao_pedagogica = '';

    if (dificuldadeResult) {
      const discriminacaoNivel =
        get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito boa' ||
        get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação boa' ||
        get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação baixa' ||
        get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
        get(dificuldadeResult, 'nivel_discriminacao') === 'Não Discrimina';


      const bisserialNivel =
        get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial muito bom' ||
        get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial bom' ||
        get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial baixo' ||
        get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial muito baixo';

      const sameData =
        (get(dificuldadeResult, 'nivel_dificuldade') === 'Fácil' &&
          get(dificuldadeResult, 'dificuldade.name') === 'Difícil') ||
        get(dificuldadeResult, 'dificuldade.name') === 'Muito Difícil' ||
        (get(dificuldadeResult, 'nivel_dificuldade') === 'Médio' &&
          get(dificuldadeResult, 'dificuldade.name') === 'Difícil') ||
        get(dificuldadeResult, 'dificuldade.name') === 'Muito Difícil' ||
        (get(dificuldadeResult, 'nivel_dificuldade') === 'Difícil' &&
          get(dificuldadeResult, 'dificuldade.name') === 'Muito Difícil');

      const dificuldadeModulos =
        (get(dificuldadeResult, 'nivel_dificuldade') === 'Fácil' &&
          get(dificuldadeResult, 'dificuldade.name') === 'Difícil') ||
        (get(dificuldadeResult, 'nivel_dificuldade') === 'Médio' &&
          get(dificuldadeResult, 'dificuldade.name') === 'Difícil');

      const dificuldadeModulo2 =
        (get(dificuldadeResult, 'nivel_dificuldade') === 'Fácil' &&
          get(dificuldadeResult, 'dificuldade.name') === 'Muito Difícil') ||
        (get(dificuldadeResult, 'nivel_dificuldade') === 'Médio' &&
          get(dificuldadeResult, 'dificuldade.name') === 'Muito Difícil') ||
        (get(dificuldadeResult, 'nivel_dificuldade') === 'Difícil' &&
          get(dificuldadeResult, 'dificuldade.name') === 'Muito Difícil');

      const nivelDificil =
        get(dificuldadeResult, 'nivel_dificuldade') === 'Difícil' &&
        get(dificuldadeResult, 'dificuldade.name') === 'Difícil';

      const nivelFacil =
        get(dificuldadeResult, 'nivel_dificuldade') === 'Fácil' &&
        get(dificuldadeResult, 'dificuldade.name') === 'Fácil';

      const dificuldadePresumidaMaior =
        (get(dificuldadeResult, 'dificuldade.name') === 'Fácil' &&
          get(dificuldadeResult, 'nivel_dificuldade') === 'Muito Fácil') ||
        (get(dificuldadeResult, 'dificuldade.name') === 'Médio' &&
          get(dificuldadeResult, 'nivel_dificuldade') === 'Fácil') ||
        get(dificuldadeResult, 'nivel_dificuldade') === 'Muito Fácil' ||
        (get(dificuldadeResult, 'dificuldade.name') === 'Difícil' &&
          get(dificuldadeResult, 'nivel_dificuldade') === 'Fácil') ||
        get(dificuldadeResult, 'nivel_dificuldade') === 'Muito Fácil' ||
        get(dificuldadeResult, 'nivel_dificuldade') === 'Médio';

      // 1
      if (
        (get(dificuldadeResult, 'dificuldade.name') === 'Fácil' &&
          get(dificuldadeResult, 'nivel_dificuldade') === 'Fácil') ||
        (get(dificuldadeResult, 'dificuldade.name') === 'Médio' &&
          get(dificuldadeResult, 'nivel_dificuldade') === 'Médio' &&
          discriminacaoNivel &&
          bisserialNivel)
      ) {
        analiseItem = 'Item adequado';
        descricao_pedagogica =
          'Item avaliou de forma adequada o que se propôs a medir. Assim,  pode-se constatar que houve aquisição  (ou não)  da habilidade questionada à turma.  A depender do desempenho apresentado, deve-se avaliar a necessidade de adequações e suportes pedagógicos.';
      }
      // 2
      else if (
        nivelDificil &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito boa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação boa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação baixa') &&
        bisserialNivel
      ) {
        analiseItem = 'Item adequado';
        descricao_pedagogica =
          'Item avaliou de forma adequada o que se propôs a medir. Assim,  pode-se constatar que houve aquisição  (ou não)  da habilidade questionada à turma.  A depender do desempenho apresentado, deve-se avaliar a necessidade de adequações e suportes pedagógicos.';
      }
      // 3
      else if (
        nivelDificil &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Não Discrimina') &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial muito bom' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial bom')
      ) {
        analiseItem = 'Item adequado';
        descricao_pedagogica =
          'Item avaliou de forma adequada o que se propôs a medir. Assim,  pode-se constatar que houve aquisição  (ou não)  da habilidade questionada à turma.  A depender do desempenho apresentado, deve-se avaliar a necessidade de adequações e suportes pedagógicos.';
      }
      //4
      else if (
        nivelDificil &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Não Discrimina') &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial baixo' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial muito baixo')
      ) {
        analiseItem = 'Item com inadequações';
        descricao_pedagogica =
          'Parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. O item teve dificuldade maior do que o presumido: pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
      }
      // 5
      else if (
        get(dificuldadeResult, 'nivel_dificuldade') !== get(dificuldadeResult, 'dificuldade.name') &&
        dificuldadePresumidaMaior &&
        get(dificuldadeResult, 'dificuldade.max_dificuldade') <=
        get(dificuldadeResult, 'acertos') &&
        bisserialNivel &&
        discriminacaoNivel
      ) {
        analiseItem = 'Item adequado com ponderações';
        descricao_pedagogica =
          'O item apresentou dificuldade menor que o presumido. Deve-se avaliar se: a) os distratores foram pouco plausíveis: neste caso deve-se rever a construção dos distratores deixando-os mais próximos da resposta correta; e/ou  b) o gabarito apresentou um atrativo que não deixou dúvidas em relação à resposta correta: neste  caso rever a construção do gabarito; ou  c) o conteúdo foi bem assimilado e por isso o item teve nível de dificulade menor que o esperado: caso deseje aumentar a dificulade do item pode-se contextualizá-lo e/ou abordar níveis mais altos de habilidade descritos na  Taxonomia de Bloom.';
      }
      //6
      else if (
        get(dificuldadeResult, 'dificuldade.name') === 'Fácil' &&
        get(dificuldadeResult, 'nivel_dificuldade') === 'Médio' &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
        get(dificuldadeResult, 'acertos') <
        get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        bisserialNivel &&
        discriminacaoNivel
      ) {
        analiseItem = 'Item adequado com ponderações';
        descricao_pedagogica =
          'O item teve dificuldade maior do que o presumido: pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
      }
      // 7 - 1 modulo
      else if (
        dificuldadeModulos &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
        get(dificuldadeResult, 'acertos') <=
        get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        bisserialNivel &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito boa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação boa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação baixa')
      ) {
        analiseItem = 'Item adequado com ponderações';
        descricao_pedagogica =
          'O item teve dificuldade maior do que o presumido: pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
      }
      // 7 - 2 modulo
      else if (
        dificuldadeModulo2 &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
        get(dificuldadeResult, 'acertos') <=
        get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial muito bom' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial bom' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial baixo') &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito boa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação boa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação baixa')
      ) {
        analiseItem = 'Item adequado com ponderações';
        descricao_pedagogica =
          'O item teve dificuldade maior do que o presumido: pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
      }
      // 8
      else if (
        sameData &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
        get(dificuldadeResult, 'acertos') <=
        get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial muito bom' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial bom') &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Não Discrimina')
      ) {
        analiseItem = 'Item adequado com ponderações';
        descricao_pedagogica =
          'O item teve dificuldade maior do que o presumido: pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
      }
      // 9 - 1 modulo
      else if (
        dificuldadeModulos &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
        get(dificuldadeResult, 'acertos') <=
        get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial baixo' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial muito baixo') &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Não Discrimina')
      ) {
        analiseItem = 'Item com inadequações';
        descricao_pedagogica =
          'O item teve dificuldade maior do que o presumido e parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. Além disso,  pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
      }
      // 9 - 2 modulo
      else if (
        dificuldadeModulo2 &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
        get(dificuldadeResult, 'acertos') <=
        get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial baixo' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial muito baixo') &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito baixa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Não Discrimina')
      ) {
        analiseItem = 'Incompátivel';
        descricao_pedagogica =
          'O item não tem coerência, pois não conseguiu medir o que se propôs. Indica que parte dos alunos de alto desempenho não marcaram a alternativa certa (ou alunos de baixo desempenho marcaram o gabarito). Neste caso conferir se: a)houve marcação errada do gabarito; b) analisar se o conteúdo foi ministrado adequadamente; ou c) se houve equivoco na construção do item. ';
      }
      // 10
      else if (
        dificuldadePresumidaMaior &&
        get(dificuldadeResult, 'dificuldade.max_dificuldade') <
        get(dificuldadeResult, 'acertos') &&
        discriminacaoNivel &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inadequado')
      ) {
        analiseItem = 'Item com inadequações';
        descricao_pedagogica =
          'O item apresentou dificuldade menor que o presumido e parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. Neste caso: a)rever a construção os distratores; ou b)avaliar se o item é incompátivel (ou seja não tem coerência);  ou c)se o gabarito foi marcado errado.';
      }
      // 11
      else if (
        nivelFacil &&
        discriminacaoNivel &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inadequado')
      ) {
        analiseItem = 'Item com inadequações';
        descricao_pedagogica =
          'Parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. Neste caso: a)rever a construção os distratores; ou  b)avaliar se o item é incompátivel (ou seja não tem coerência);  ou c) se o gabarito foi marcado errado.';
      }
      // 12
      else if (
        get(dificuldadeResult, 'nivel_dificuldade') === get(dificuldadeResult, 'dificuldade.name') &&
        nivelDificil &&
        discriminacaoNivel &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inadequado')
      ) {
        analiseItem = 'Item incompatível';
        descricao_pedagogica =
          'O item não tem coerência, pois não conseguiu medir o que se propôs. Indica que parte dos alunos de alto desempenho não marcaram a alternativa certa (ou alunos de baixo desempenho marcaram o gabarito). Neste caso conferir se: a)houve marcação errada do gabarito; b) analisar se o conteúdo foi ministrado adequadamente; ou c) se houve equivoco na construção do item.';
      }
      // 13
      else if (
        sameData &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
        get(dificuldadeResult, 'acertos') <=
        get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        discriminacaoNivel &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inadequado')
      ) {
        analiseItem = 'Item incompatível';
        descricao_pedagogica =
          'O item não tem coerência, pois não conseguiu medir o que se propôs. Indica que parte dos alunos de alto desempenho não marcaram a alternativa certa (ou alunos de baixo desempenho marcaram o gabarito). Neste caso conferir se: a)houve marcação errada do gabarito; b) analisar se o conteúdo foi ministrado adequadamente; ou c) se houve equivoco na construção do item.';
      }
      // 14
      else if (
        get(dificuldadeResult, 'nivel_dificuldade') === 'Médio' &&
        get(dificuldadeResult, 'dificuldade.name') === 'Médio' &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação baixa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação boa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito boa') &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inadequado')
      ) {
        analiseItem = 'Item com inadequações';
        descricao_pedagogica =
          'Parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. Neste caso: a)rever a construção os distratores; ou  b)avaliar se o item é incompátivel (ou seja não tem coerência);  ou c) se o gabarito foi marcado errado.';
      }
      // 15
      else if (
        get(dificuldadeResult, 'nivel_dificuldade') === get(dificuldadeResult, 'dificuldade.name') &&
        get(dificuldadeResult, 'nivel_dificuldade') === 'Médio' &&
        get(dificuldadeResult, 'dificuldade.name') === 'Médio' &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Não Discrimina' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito baixa') &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inadequado')
      ) {
        analiseItem = 'Item incompatível';
        descricao_pedagogica =
          'O item não tem coerência, pois não conseguiu medir o que se propôs. Indica que parte dos alunos de alto desempenho não marcaram a alternativa certa (ou alunos de baixo desempenho marcaram o gabarito). Neste caso conferir se: a)houve marcação errada do gabarito; b) analisar se o conteúdo foi ministrado adequadamente; ou c) se houve equivoco na construção do item.';
      }
      // 16
      if (
        get(dificuldadeResult, 'dificuldade.name') === 'Difícil' &&
        get(dificuldadeResult, 'nivel_dificuldade') === 'Médio' &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
        get(dificuldadeResult, 'acertos') <=
        get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inadequado') &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação baixa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação boa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito boa')
      ) {
        analiseItem = 'Item com inadequações';
        descricao_pedagogica =
          'O item apresentou dificuldade menor que o presumido e parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. Neste caso: a)rever a construção os distratores; ou b)avaliar se o item é incompátivel (ou seja não tem coerência);  ou c)se o gabarito foi marcado errado.';
      }
      // 17
      else if (
        get(dificuldadeResult, 'dificuldade.name') === 'Difícil' &&
        get(dificuldadeResult, 'nivel_dificuldade') === 'Médio' &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
        get(dificuldadeResult, 'acertos') <=
        get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inadequado') &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação baixa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Não Discrimina')
      ) {
        analiseItem = 'Item incompatível';
        descricao_pedagogica =
          'O item não tem coerência, pois não conseguiu medir o que se propôs. Indica que parte dos alunos de alto desempenho não marcaram a alternativa certa (ou alunos de baixo desempenho marcaram o gabarito). Neste caso conferir se: a)houve marcação errada do gabarito; b) analisar se o conteúdo foi ministrado adequadamente; ou c) se houve equivoco na construção do item. ';
      }
      // 18
      if (
        get(dificuldadeResult, 'dificuldade.name') === 'Fácil' &&
        get(dificuldadeResult, 'nivel_dificuldade') === 'Médio' &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >=
        get(dificuldadeResult, 'acertos') <=
        get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inadequado') &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito boa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação boa' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação baixa')
      ) {
        analiseItem = 'Item com inadequações';
        descricao_pedagogica =
          'O item teve dificuldade maior do que o presumido e parte dos alunos de alto desempenho não marcaram o gabarito (ou alunos de baixo desempenho marcaram o gabarito). Deve-se avaliar, se os distratores apresentaram alguma "pegadinha" que confundiram os alunos de alto desempenho, fazendo com que escolhessem um distrator como gabarito. Além disso,  pode indicar que o conteúdo ministrado (ou conteúdos que seriam pré-requisitos) não foi bem assimilado pelos alunos, por isso o nível de dificuldade foi maior que o esperado. Avaliar a necessidade de reforçar ou retomar  o conteúdo.';
      }
      // 19
      else if (
        get(dificuldadeResult, 'dificuldade.name') === 'Fácil' &&
        get(dificuldadeResult, 'nivel_dificuldade') === 'Médio' &&
        get(dificuldadeResult, 'dificuldade.min_dificuldade') >
        get(dificuldadeResult, 'acertos') <
        get(dificuldadeResult, 'dificuldade.max_dificuldade') &&
        (get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inapropriado' ||
          get(dificuldadeResult, 'nivel_bisserial') === 'Bisserial inadequado') &&
        (get(dificuldadeResult, 'nivel_discriminacao') === 'Não Discrimina' ||
          get(dificuldadeResult, 'nivel_discriminacao') === 'Discriminação muito baixa')
      ) {
        analiseItem = 'Item incompatível';
        descricao_pedagogica =
          'O item não tem coerência, pois não conseguiu medir o que se propôs. Indica que parte dos alunos de alto desempenho não marcaram a alternativa certa (ou alunos de baixo desempenho marcaram o gabarito). Neste caso conferir se: a)houve marcação errada do gabarito; b) analisar se o conteúdo foi ministrado adequadamente; ou c) se houve equivoco na construção do item.';
      }
    }

    return (
      <React.Fragment>
        <Form>
          <InputSelect
            label="Análise"
            col="col-md-12"
            field="analises"
            options={get(item, 'analises', [])}
            onChange={value => {
              this.fetchAnalises(value)
            }}
          />
          {fetchingAnalise && <Loading />}
          {!fetchingAnalise && itemSelecionado &&
            <div className="row pt-4 mt-4 mb-4 pb-4">
              <ParametroItem
                col="col-3"
                name="Dificuldade"
                title="Dificuldade Presumida"
                color={get(dificuldadeResult, 'dificuldade.color')}
                label={get(dificuldadeResult, 'dificuldade.name')}
              />
              <ParametroItem
                col="col-3"
                name="Dificuldade"
                title="Dificuldade mensurada"
                value={this.dificuldade}
                color={get(this.parametrosGabarito, 'cor_dificuldade')}
                label={get(this.parametrosGabarito, 'nivel_dificuldade')}
              />
              <ParametroItem
                col="col-3"
                name="Discriminação"
                title="Índice de discriminação"
                value={this.discriminacao}
                color={get(this.parametrosGabarito, 'cor_discriminacao')}
                label={get(this.parametrosGabarito, 'nivel_discriminacao')}
              />
              <ParametroItemAnalise
                col="col-3"
                name="Classificacao"
                title="Classificação"
                label={analiseItem}
              />

              <hr className="hr-analise" />
              <div className="col-12 pb-3">
                <p className="azul">
                  <b>Análise pedagógica</b>
                </p>
                <span className="span-analise" style={{ textAlign: 'justify' }}>
                  {descricao_pedagogica}
                </span>
              </div>
            </div>
          }
        </Form>
      </React.Fragment>
    )
  }

  renderMatrizesReferencia() {
    const matrizes_referencia = get(this.state, 'matrizes_referencia', []);
    const { fetchingMatrizesReferencia } = this.state;

    if (fetchingMatrizesReferencia) return <Loading />;
    if (matrizes_referencia.length === 0)
      return (
        <p className="azul">
          <i className="fas fa-exclamation-circle" /> Este item não possui
          matrizes de referência.
        </p>
      );

    return (
      <div>
        <ul className="style-list">
          {matrizes_referencia.map((m) => (
            <li key={m.id}>
              {get(m, 'matriz_referencia', '-')}
              <ul className="style-list">
                {map(m.competencias, (c) => (
                  <React.Fragment key={c.competencia}>
                    <li>{c.competencia}</li>
                    <ul className="style-list">
                      {map(c.habilidades, (h) => (
                        <li>{h}</li>
                      ))}
                    </ul>
                  </React.Fragment>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  renderPalavrasChave() {
    let palavras_chave = get(this.props, 'item.palavras_chave');
    palavras_chave = palavras_chave ? palavras_chave.split(',') : [];

    if (palavras_chave.length === 0) {
      return '-';
    }

    return map(palavras_chave, (x, i) => (
      <span key={`${x}${i}`} className="badge badge-secondary mr-1">
        {x}
      </span>
    ));
  }

  renderFonte() {
    const { ocultar_nome_autor } = this.props;
    return (
      <div>
        <div className="row">
          <div className="col-sm-6">
            <LabelView title="Ano" text={get(this.props, 'item.ano', '-')} />
          </div>
        </div>
        <div className="row">
          {!ocultar_nome_autor && (
            <div className="col-sm-6">
              <LabelView
                title="Autor"
                text={get(this.props, 'item.autor', '-')}
              />
            </div>
          )}
          <div className="col-sm-6">
            <LabelView
              title="Instrumento de avaliação"
              text={get(this.props, 'item.instrumento.descricao', '-')}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <LabelView
              title="Dificuldade presumida"
              text={get(this.props, 'item.dificuldade.descricao', '-')}
            />
          </div>
          <div className="col-sm-6">
            <LabelView
              title="Palavras-chave"
              text={this.renderPalavrasChave()}
            />
          </div>
        </div>
      </div>
    );
  }

  renderBibliografias() {
    const bibliografias = get(this.props, 'item.bibliografias', []);
    const { fetchingBibliografiaComplementar } = this.state;

    if (fetchingBibliografiaComplementar) return <Loading />;
    if (bibliografias.length === 0) {
      return (
        <p className="azul">
          <i className="fas fa-exclamation-circle" /> Este item não possui
          referências bibliográficas.
        </p>
      );
    }

    return (
      <div>
        {bibliografias.map((b, i) => (
          <React.Fragment key={b.id}>
            {i > 0 && <hr />}
            <div className="row">
              <div className="col-md-6">
                <LabelView title="Título" text={get(b, 'titulo', '-')} />
              </div>
              <div className="col-md-6">
                <LabelView title="Autor" text={get(b, 'autor', '-')} />
              </div>
              <div className="col-md-4">
                <LabelView title="Capítulo" text={get(b, 'capitulo', '-')} />
              </div>
              <div className="col-md-4">
                <LabelView
                  title="Página inicial"
                  text={get(b, 'pagina_inicial', '-')}
                />
              </div>
              <div className="col-md-4">
                <LabelView
                  title="Página final"
                  text={get(b, 'pagina_final', '-')}
                />
              </div>
              <div className="col-md-12">
                <LabelView title="Link" text={get(b, 'link', '-')} />
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    );
  }

  renderBibliografiasComplementares() {
    const bibliografia_complementar = get(
      this.props,
      'item.bibliografia_complementar',
      []
    );

    if (bibliografia_complementar.length === 0) {
      return (
        <p className="azul">
          <i className="fas fa-exclamation-circle" /> Este item não possui
          referências bibliográficas
        </p>
      );
    }

    return (
      <div>
        {bibliografia_complementar.map((b, i) => (
          <React.Fragment key={b.id}>
            {i > 0 && <hr />}
            <div className="row">
              <div className="col-md-6">
                <LabelView
                  title="Disciplina"
                  text={get(b, 'disciplina.descricao', '-')}
                />
              </div>
              <div className="col-md-6">
                <LabelView title="Autor" text={get(b, 'autor', '-')} />
              </div>
              <div className="col-md-6">
                <LabelView title="Obra" text={get(b, 'obra', '-')} />
              </div>
              <div className="col-md-6">
                <LabelView title="Edição" text={get(b, 'edicao', '-')} />
              </div>
              <div className="col-md-6">
                <LabelView title="Tema" text={get(b, 'edicao', '-')} />
              </div>
              <div className="col-md-6">
                <LabelView title="Subtema" text={get(b, 'sub_tema', '-')} />
              </div>
              <div className="col-md-6">
                <LabelView
                  title="Página inicial"
                  text={get(b, 'pagina_inicial', '-')}
                />
              </div>
              <div className="col-md-6">
                <LabelView
                  title="Página final"
                  text={get(b, 'pagina_final', '-')}
                />
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    );
  }

  renderParametros() {
    const item = get(this.props, 'item') || {};

    if (!item.calibrado) {
      return (
        <p className="azul">
          <i className="fas fa-exclamation-circle" /> Este item não foi
          calibrado.
        </p>
      );
    }

    return (
      <React.Fragment>
        <div className="row">
          <LabelView
            col="col-md-4"
            title="Bisserial"
            text={get(item, 'bisserial', '-')}
          />
          <LabelView
            col="col-md-4"
            title="Discriminação"
            text={get(item, 'discriminacao', '-')}
          />
          <LabelView
            col="col-md-4"
            title="Dificuldade (porcentagem de acertos)"
            text={get(item, 'acertos', '-')}
          />
          <LabelView
            col="col-md-4"
            title="A (discriminação)"
            text={get(item, 'pa', '-')}
          />
          <LabelView
            col="col-md-4"
            title="B (dificuldade)"
            text={get(item, 'pb', '-')}
          />
          <LabelView
            col="col-md-4"
            title="C (acerto casual)"
            text={get(item, 'pc', '-')}
          />
        </div>
      </React.Fragment>
    );
  }

  renderHistoricoUtilizacao() {
    const { historicoUtilizacao } = this.state;
    const { fetchingHistoricoUtilizacao } = this.state;

    if (fetchingHistoricoUtilizacao) return <Loading />;
    if (Object.keys(historicoUtilizacao).length === 0)
      return (
        <p className="azul">
          <i className="fas fa-exclamation-circle" /> Este item não foi
          utilizado.
        </p>
      );

    return (
      <React.Fragment>
        {historicoUtilizacao.analisados.map((item) => (
          <>
            <div className="card mb-10" key={item.id}>
              <label>{get(item, 'avaliacao_name', '-')}</label>
              <div className="row mx-auto">
                <LabelView
                  col="col-md-4"
                  title="Bisserial"
                  text={get(item, 'bisserial', '-')}
                />
                <LabelView
                  col="col-md-4"
                  title="Discriminação"
                  text={get(item, 'discriminacao', '-')}
                />
                <LabelView
                  col="col-md-4"
                  title="Dificuldade (porcentagem de acertos)"
                  text={`${get(item, 'dificuldade', '-')}%`}
                />
                <LabelView
                  col="col-md-4"
                  title="A (discriminação)"
                  text={get(item, 'pa', '-')}
                />
                <LabelView
                  col="col-md-4"
                  title="B (dificuldade)"
                  text={get(item, 'pb', '-')}
                />
                <LabelView
                  col="col-md-4"
                  title="C (acerto casual)"
                  text={get(item, 'pc', '-')}
                />
              </div>
            </div>
            <br />
          </>
        ))}
        {historicoUtilizacao.nao_analisados.map((item) => (
          <>
            <div className="card" key={item.id}>
              <dl>
                <label>{get(item, 'avaliacao_name', '-')}</label>
                <div className="col-sm-9">Não foi realizada análise</div>
              </dl>
            </div>
            <br />
          </>
        ))}
      </React.Fragment>
    );
  }

  render() {
    const { labels, hasParametro, border } = this.props;
    const borderStyle = border ? {} : { border: 'none' };

    return (
      <div className="card-item card-alone">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({
                active: this.state.activeTab === 'conteudo'
              })}
              onClick={() => this.toggle('conteudo')}
            >
              Conteúdo
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: this.state.activeTab === 'dados'
              })}
              onClick={() => this.toggle('dados')}
            >
              Dados
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: this.state.activeTab === 'matrizes_referencia'
              })}
              onClick={() => this.toggle('matrizes_referencia')}
            >
              Matriz de referência
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: this.state.activeTab === 'fonte'
              })}
              onClick={() => this.toggle('fonte')}
            >
              Fonte
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: this.state.activeTab === 'bibliografias'
              })}
              onClick={() => this.toggle('bibliografias')}
            >
              Referências
            </NavLink>
          </NavItem>
          {hasParametro && (
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === 'parametros'
                })}
                onClick={() => this.toggle('parametros')}
              >
                Parâmetros
              </NavLink>
            </NavItem>
          )}
          <NavItem>
            <NavLink
              className={classnames({
                active: this.state.activeTab === 'historico_utilizacao'
              })}
              onClick={() => this.toggle('historico_utilizacao')}
            >
              Histórico de Utilização
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: this.state.activeTab === 'analise_item'
              })}
              onClick={() => this.toggle('analise_item')}
            >
              Análise do Item
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: this.state.activeTab === 'revisao_item'
              })}
              onClick={() => this.toggle('revisao_item')}
            >
              Histórico de revisão
            </NavLink>
          </NavItem>
        </Nav>

        <div className="card-body no-radius-top" style={borderStyle}>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="conteudo">
              <ItemConteudo labels={labels} item={this.props.item} />
            </TabPane>
            <TabPane tabId="dados">{this.renderDados()}</TabPane>
            <TabPane tabId="matrizes_referencia">
              {this.renderMatrizesReferencia()}
            </TabPane>
            <TabPane tabId="fonte">{this.renderFonte()}</TabPane>
            <TabPane tabId="bibliografias">
              {get(this.state, 'possuiBibliografiaComplementar') ? (
                <>{this.renderBibliografiasComplementares()}</>
              ) : (
                <>{this.renderBibliografias()}</>
              )}
            </TabPane>
            {hasParametro && (
              <TabPane tabId="parametros">{this.renderParametros()}</TabPane>
            )}
            <TabPane tabId="historico_utilizacao">
              {this.renderHistoricoUtilizacao()}
            </TabPane>
            <TabPane tabId="analise_item">
              {this.renderAnaliseItem()}
            </TabPane>
            <TabPane tabId="revisao_item">
              {this.renderRevisaoItem()}
            </TabPane>
          </TabContent>
        </div>
      </div>
    );
  }
}

export default Item;
